export default __webpack_public_path__ + "static/media/t.min.23f0f60f.png";